import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, Paper, Divider, CircularProgress } from "@mui/material";
import { getEntityIncidentById } from "../../api";
import Header from "../Header"; // Import the Header component

const EntityIncidentView = () => {
  const { id } = useParams(); // Extract ID from URL parameters
  const [incident, setIncident] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIncident = async () => {
      try {
        const response = await getEntityIncidentById(id); // Fetch incident data by ID
        setIncident(response.data.data);
      } catch (error) {
        console.error("Error fetching incident:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchIncident();
  }, [id]);

  if (loading) {
    return (
      <Box p={3} display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  if (!incident) {
    return (
      <Box p={3}>
        <Typography variant="h6" color="error">
          Incident not found.
        </Typography>
      </Box>
    );
  }

  const { entityInfo, sensorData, trigger, createdAt } = incident;

  return (
    <Box p={3} maxWidth={800} mx="auto">
      <Paper  sx={{ p: 3 }}>
       <Header title="Incident Details" />
        <Divider sx={{ mb: 3 }} />

        {/* Incident Section */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom>
            General Information
          </Typography>
          <Typography><strong>Incident ID:</strong> {incident._id}</Typography>
          <Typography><strong>Created At:</strong> {new Date(createdAt).toLocaleString()}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Entity Section */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom>
            Entity Information
          </Typography>
          <Typography><strong>Entity Name:</strong> {entityInfo?.name || "N/A"}</Typography>
          <Typography>
            <strong>License Plate:</strong>{" "}
            {entityInfo?.keys.find((key) => key.keyName === "LicensePlate")?.value || "N/A"}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Trigger Section */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom>
            Trigger Details
          </Typography>
          <Typography><strong>Trigger Name:</strong> {trigger?.name || "N/A"}</Typography>
          {trigger?.configuration?.geofences?.length > 0 && (
            <Typography>
              <strong>Geofences:</strong>{" "}
              {trigger.configuration.geofences.map((fence, index) => (
                <div key={index}>
                  <Typography variant="body2">
                    Coordinates: {JSON.stringify(fence.geometry.coordinates)}
                  </Typography>
                </div>
              ))}
            </Typography>
          )}
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Sensor Data Section */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom>
            Sensor Data
          </Typography>
          {sensorData ? (
            <>
              <Typography><strong>Latitude:</strong> {sensorData.data.latitude || "N/A"}</Typography>
              <Typography><strong>Longitude:</strong> {sensorData.data.longitude || "N/A"}</Typography>
              <Typography><strong>Altitude:</strong> {sensorData.data.altitude || "N/A"}</Typography>
            </>
          ) : (
            <Typography>No sensor data available.</Typography>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default EntityIncidentView;
